import React from 'react';
import styled from 'styled-components';
import LabelSpan from './LabelSpan';

const getDisplayDictationContent = (dictation, onCommentClick, source) => {
  if (onCommentClick && !dictation) {
    return 'Add comment';
  }

  if (dictation) {
    return source === 'PDF' ? dictation : `Comment: ${dictation}`;
  }

  return '';
};

interface CommentSpanProps {
  $isEmptyInput: boolean;
}

const CommentSpan = styled(LabelSpan)<CommentSpanProps>`
  color: ${(props) =>
    props.$isEmptyInput ? 'var(--color-gray)' : 'var(--color-mint)'};
  font-weight: ${(props) => (props.$isEmptyInput ? 'bold' : '200')};

  &:hover {
    cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  }
`;

const CommentDiv = styled.div`
  color: rgb(159, 173, 188);
  padding: 5px;
  word-break: break-word;

  &:hover {
    cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  }
`;

interface CommentLabelProps {
  dictation: string | null | undefined;
  onCommentClick?: () => void;
  source?: string; // source is used to identify the component that calls CommentLabel
}

const CommentLabel: React.FC<CommentLabelProps> = ({
  dictation,
  onCommentClick,
  source
}) => {
  const isEmptyInput = !dictation;
  const content = getDisplayDictationContent(dictation, onCommentClick, source);

  if (source === 'PDF') {
    return (
      <CommentDiv {...(onCommentClick && { onClick: onCommentClick })}>
        {content}
      </CommentDiv>
    );
  }

  return (
    <CommentSpan
      {...(onCommentClick && { onClick: onCommentClick })}
      $isEmptyInput={isEmptyInput}
    >
      {content}
    </CommentSpan>
  );
};

export default CommentLabel;
